const equalOperation = (leftOperand, rightOperand) => {

	if(Array.isArray(leftOperand) && leftOperand.length === 1){
		leftOperand = leftOperand[0];
	}

	leftOperand = typeof leftOperand === 'undefined' ? null : leftOperand;

	if(typeof leftOperand === 'number' && typeof rightOperand === 'string'){
		let newRightOperand = Number(rightOperand);
		if(rightOperand === "" ) return false;
		return leftOperand === newRightOperand;
	}

	return String(leftOperand) === String(rightOperand);
};

const equalSize = (leftOperand, rightOperand, fieldOptions) => {
	let optionsLength = fieldOptions.length;

	return String(rightOperand) === String(optionsLength);
}

const contains = (leftOperand, rightOperand) => {
	if(typeof leftOperand === 'string')
		return leftOperand.includes(rightOperand);
	else if(typeof leftOperand === 'number'){
		return String(leftOperand.toFixed(2)).includes(rightOperand);
	}
	else if(typeof leftOperand === 'object')
		return leftOperand[0].includes(rightOperand);

}

const containsError = (leftOperand, rightOperand) => {
	if(rightOperand === true)
		return rightOperand
}

const notContainsError = (leftOperand, rightOperand) => {
	if(rightOperand === false)
		return true
	else
		return false
}

const parseNumber = (number) => {
	const parsedNumber = parseFloat(number);
	return isNaN(parsedNumber) ? 0 : parsedNumber;
};

export const OperatorFunctions = {
	NOT: (operand) => !operand,
	EQUAL: equalOperation,
	NOT_EQUAL: (leftOperand, rightOperand) => !OperatorFunctions.EQUAL(leftOperand, rightOperand),
	IS_EMPTY: (operand) => operand === undefined || operand === null || operand.match(/^\s*$/),
	GREATER_THAN: (leftOperand, rightOperand) => parseNumber(leftOperand) > parseNumber(rightOperand),
	LESSER_THAN: (leftOperand, rightOperand) => parseNumber(leftOperand) < parseNumber(rightOperand),
	GREATER_THAN_OR_EQUAL: (leftOperand, rightOperand) => parseNumber(leftOperand) >= parseNumber(rightOperand),
	LESSER_THAN_OR_EQUAL: (leftOperand, rightOperand) => parseNumber(leftOperand) <= parseNumber(rightOperand),
	OR: (leftOperand, rightOperand) => leftOperand || rightOperand,
	AND: (leftOperand, rightOperand) => leftOperand && rightOperand,
	ADD: (leftOperand, rightOperand) => parseNumber(leftOperand) + parseNumber(rightOperand),
	SUB: (leftOperand, rightOperand) => parseNumber(leftOperand) - parseNumber(rightOperand),
	MUL: (leftOperand, rightOperand) => parseNumber(leftOperand) * parseNumber(rightOperand),
	DIV: (leftOperand, rightOperand) => parseNumber(leftOperand) / parseNumber(rightOperand),
	MOD: (leftOperand, rightOperand) => parseNumber(leftOperand) % parseNumber(rightOperand),
	CONCAT: (leftOperand, rightOperand) => String(leftOperand) + String(rightOperand),
	MATCH: (leftOperand, rightOperand) => String(leftOperand).match(new RegExp(rightOperand)),
	INCLUDES: (leftOperand, rightOperand) => Array.isArray(leftOperand) && leftOperand.includes(rightOperand),
	NOT_INCLUDES: (leftOperand, rightOperand) => !OperatorFunctions.INCLUDES(leftOperand, rightOperand),
	CONTAINS: contains,
	CONTAINS_ERROR: containsError,
	NOT_CONTAINS_ERROR: notContainsError,
	SIZE_EQUAL: equalSize,
	SIZE_NOT_EQUAL: (leftOperand, rightOperand, fieldOptions) => String(rightOperand) !== String(fieldOptions.length),
	SIZE_GREATER_THAN: (leftOperand, rightOperand, fieldOptions) => parseNumber(fieldOptions.length) > parseNumber(rightOperand),
	SIZE_GREATER_THAN_OR_EQUAL: (leftOperand, rightOperand, fieldOptions) => parseNumber(fieldOptions.length) >= parseNumber(rightOperand),
	SIZE_LESSER_THAN: (leftOperand, rightOperand, fieldOptions) => parseNumber(fieldOptions.length) < parseNumber(rightOperand),
	SIZE_LESSER_THAN_OR_EQUAL: (leftOperand, rightOperand, fieldOptions) => parseNumber(fieldOptions.length) <= parseNumber(rightOperand)
};

export default OperatorFunctions;
